// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1z62t","ranges":"BmiRanges_ranges__8-MHU"};